"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_HEIGHT = exports.DEFAULT_HEX_FONT_COLOR = exports.HEXAGON_DIP_RATIO = exports.USA_MAP_WIDTH_HEIGHT_RATIO = void 0;
/* eslint-disable react-hooks/rules-of-hooks */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const measurements_1 = require("../../utilities/measurements");
const usStates_1 = require("./usStates");
exports.USA_MAP_WIDTH_HEIGHT_RATIO = 1.7;
exports.HEXAGON_DIP_RATIO = 0.288675;
exports.DEFAULT_HEX_FONT_COLOR = '#212121';
exports.MIN_HEIGHT = 100;
const Cartogram = _ref => {
  let {
    data = [],
    strokeWidth = 2,
    fontColor = exports.DEFAULT_HEX_FONT_COLOR,
    fontSize = 12,
    fontWeight = 600,
    spacing = 4,
    backgroundColor = 'usa-gray',
    strokeColor = backgroundColor,
    height: rawHeight = undefined,
    width: rawWidth = 500,
    showUSA = false,
    makeUSABigger = true,
    onMouseOver = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  if (rawWidth === 0) {
    return null;
  }
  const {
    width,
    height
  } = (0, measurements_1.getMapDimensions)(exports.USA_MAP_WIDTH_HEIGHT_RATIO, rawWidth, rawHeight);
  if (height < exports.MIN_HEIGHT) {
    console.warn(`Height cannot be lower than ${exports.MIN_HEIGHT}.`);
  }
  const itemContainerWidth = width / usStates_1.USGrid[0].length;
  const itemContainerHeight = itemContainerWidth * 1.1547;
  const defaultStrokeWidth = lodash_1.default.isNumber(strokeWidth) ? strokeWidth : 2;
  const hexagons = lodash_1.default.chain((0, usStates_1.stateWithUSAIdx)(usStates_1.USGrid)).map(stateProps => {
    const stateData = lodash_1.default.chain(data).filter({
      fips: stateProps.properties.fips
    }).first().value();
    const containerXCoord = stateProps.j * itemContainerWidth + (stateProps.i % 2 > 0 ? itemContainerWidth / 2 : 0);
    const containerYCoord = stateProps.i * itemContainerHeight - stateProps.i * exports.HEXAGON_DIP_RATIO * itemContainerHeight;
    // if the stroke is too big, change it to occupy 80% of the hexagon
    // (leaving something in the middle)
    const constrainedStrokeWidth = lodash_1.default.min([lodash_1.default.get(stateData, 'strokeWidth', defaultStrokeWidth), 0.4 * (itemContainerWidth - spacing)]);
    let itemXCoord = containerXCoord + spacing / 2 + constrainedStrokeWidth / 2;
    const itemYCoord = containerYCoord + spacing / 2 + constrainedStrokeWidth / 2;
    let itemWidth = itemContainerWidth - spacing - constrainedStrokeWidth;
    let itemHeight = itemContainerHeight - spacing - constrainedStrokeWidth;
    if (stateProps.properties.fips === 'US' && makeUSABigger) {
      itemXCoord -= (exports.USA_MAP_WIDTH_HEIGHT_RATIO * itemWidth - itemWidth) / 2;
      itemWidth *= exports.USA_MAP_WIDTH_HEIGHT_RATIO;
      itemHeight *= exports.USA_MAP_WIDTH_HEIGHT_RATIO;
    }
    const polygonArr = [[itemXCoord + itemWidth / 2, itemYCoord], [itemXCoord + itemWidth, itemYCoord + itemHeight * exports.HEXAGON_DIP_RATIO], [itemXCoord + itemWidth, itemYCoord + itemHeight * (1 - exports.HEXAGON_DIP_RATIO)], [itemXCoord + itemWidth / 2, itemYCoord + itemHeight], [itemXCoord, itemYCoord + itemHeight * (1 - exports.HEXAGON_DIP_RATIO)], [itemXCoord, itemYCoord + itemHeight * exports.HEXAGON_DIP_RATIO] // left, top
    ];

    const center = [itemXCoord + itemWidth / 2, itemYCoord + itemHeight / 2];
    return {
      fips: stateProps.properties.fips,
      hexStrokeWidth: constrainedStrokeWidth,
      hexagon: {
        points: polygonArr,
        strokeWidth: constrainedStrokeWidth,
        stroke: (0, colors_1.parseColor)(lodash_1.default.get(stateData, 'strokeColor', strokeColor), colors_1.COLOR_PALETTE['usa-gray']),
        fill: (0, colors_1.parseColor)(lodash_1.default.get(stateData, 'backgroundColor', backgroundColor), colors_1.COLOR_PALETTE['usa-gray'])
      },
      label: {
        x: center[0],
        y: center[1] + constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO * fontSize,
        text: stateProps.properties.abbr,
        fontSize: lodash_1.default.get(stateData, 'fontSize', fontSize),
        fill: (0, colors_1.parseColor)(lodash_1.default.get(stateData, 'fontColor', fontColor), exports.DEFAULT_HEX_FONT_COLOR),
        fontWeight: lodash_1.default.get(stateData, 'fontWeight', fontWeight)
      },
      opacity: 1
    };
  }).orderBy(['hexagon.stroke'], ['desc']).value().filter(f => !(showUSA === false && f.fips === 'US')).map(_ref2 => {
    let {
      hexagon: {
        strokeWidth: hexStrokeWidth,
        fill: hexFill,
        stroke: hexStroke,
        points
      },
      label: {
        fill: labelFill,
        fontSize: labelFontSize,
        fontWeight: labelFontWeight,
        x,
        y,
        text
      },
      fips,
      opacity
    } = _ref2;
    return {
      fips,
      points,
      hexFill,
      hexStrokeWidth,
      hexStroke,
      labelFill,
      labelFontSize,
      labelFontWeight,
      x,
      y,
      opacity,
      text
    };
  });
  return react_1.default.createElement("g", {
    key: "cartogram-component",
    style: {
      width,
      height
    }
  }, hexagons.map(_ref3 => {
    let {
      fips,
      points,
      hexFill,
      hexStrokeWidth,
      hexStroke,
      labelFill,
      labelFontSize,
      labelFontWeight,
      x,
      y,
      text
    } = _ref3;
    return react_1.default.createElement("g", {
      key: fips
    }, react_1.default.createElement("polygon", {
      fill: hexFill,
      stroke: hexStroke,
      strokeWidth: hexStrokeWidth,
      points: points,
      onMouseOver: event => onMouseOver(event, fips),
      onMouseOut: event => onMouseOut(event, fips),
      onClick: event => onClick(event, fips)
    }), react_1.default.createElement("text", {
      textAnchor: "middle",
      fill: labelFill,
      x: x,
      y: y,
      fontWeight: labelFontWeight,
      fontSize: labelFontSize,
      style: {
        pointerEvents: 'none'
      }
    }, text));
  }));
};
Cartogram.propTypes = {
  /**
   * State data to display on the map, indexed by fips number (string).
   * Each state has a backgroundColor (string),
   * strokeColor (string), and strokeWidth (number).
   * Border strokes with defined colors will appear on top of those with undefined color.
   */
  data: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    strokeColor: prop_types_1.string,
    strokeWidth: prop_types_1.number,
    backgroundColor: prop_types_1.string,
    fips: prop_types_1.string.isRequired,
    fontColor: prop_types_1.string,
    fontSize: prop_types_1.number,
    fontWeight: prop_types_1.number
  })),
  /**
   * default state stroke color
   */
  strokeColor: prop_types_1.string,
  /**
   * default state background color
   */
  backgroundColor: prop_types_1.string,
  /**
   * Default stroke width for all the hexagons. This variable is a number
   */
  strokeWidth: prop_types_1.number,
  /**
   * default font color for labels
   */
  fontColor: prop_types_1.string,
  /**
   * Font size for the labels. Font size is a number, it sets the default font size for the labels.
   */
  fontSize: prop_types_1.number,
  /**
   * Font weight for the labels.
   * Font weight is a number, it sets the default font weight for the labels.
   */
  fontWeight: prop_types_1.number,
  /**
   * Spacing between the different hexagons in pixels.
   * This sets the space between hexagons on the cartogram.
   */
  spacing: prop_types_1.number,
  /**
   * Height for the cartogram.
   * The cartogram will automatically set it's width to maintain it's aspect ratio. Will override provided width
   */
  height: prop_types_1.number,
  /**
   * Width for the cartogram.
   * The cartogram will set it's height automatically to maintain it's aspect ratio.
   */
  width: prop_types_1.number,
  /**
   * function to activate on click
   * parameters: (event, fips)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, fips)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, fips)
   */
  onMouseOut: prop_types_1.func,
  /**
   * Option to show USA or not
   */
  showUSA: prop_types_1.bool,
  /**
   * Option to make USA Bigger or not. For this to work properly the option showUSA should be true
   */
  makeUSABigger: prop_types_1.bool
};
exports.default = Cartogram;